import { selectHasMultiLocalCurrencies } from 'legacy/lut/features/partner360/configuration/selectors/selectHasMultiLocalCurrencies'
import { useAppDispatch } from 'legacy/lut/hooks/useAppDispatch'
import { useCallback, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { DEFAULT_CURRENCY } from '../../../lib/getAvailableCockpitCurrencies'
import { setCockpitCurrency } from '../../../model/financialCockpitSlice'
import { selectAvailableCockpitCurrencies } from '../../../model/selectors/selectAvailableCockpitCurrencies'
import { selectCockpitCurrency } from '../../../model/selectors/selectCockpitCurrency'
import { selectCockpitMode } from '../../../model/selectors/selectCockpitMode'

/** The partner's multi-currency rule also applies to the deck shown over section windows.
 * Manager aggregates have no single partner's currency setting. */
export const useCockpitCurrency = () => {
  const dispatch = useAppDispatch()
  const mode = useSelector(selectCockpitMode)
  const selectedCurrency = useSelector(selectCockpitCurrency)
  const availableCurrencies = useSelector(selectAvailableCockpitCurrencies)
  const hasMultiLocalCurrencies = useSelector(selectHasMultiLocalCurrencies)
  const isCurrencyDisabled = mode === 'partner' && hasMultiLocalCurrencies

  useEffect(() => {
    if (isCurrencyDisabled && selectedCurrency !== DEFAULT_CURRENCY) {
      // The existing sync listener also updates the shared currency used by plan sections.
      dispatch(setCockpitCurrency(DEFAULT_CURRENCY))
    }
  }, [dispatch, isCurrencyDisabled, selectedCurrency])

  const selectCurrency = useCallback(
    (key: string) => {
      if (!isCurrencyDisabled) dispatch(setCockpitCurrency(key))
    },
    [dispatch, isCurrencyDisabled]
  )

  const currency = isCurrencyDisabled
    ? DEFAULT_CURRENCY
    : availableCurrencies.includes(selectedCurrency)
      ? selectedCurrency
      : availableCurrencies[0]

  return { currency, availableCurrencies, isCurrencyDisabled, selectCurrency }
}
